import React, { useContext, useEffect } from "react"
import {
  Grid,
  Button,
  Tooltip,
  TextField,
  IconButton,
  InputAdornment,
  CircularProgress
} from "@material-ui/core"
import HelpIcon from "@material-ui/icons/Help"
import { useForm } from "react-hook-form"
import { I18nContext } from "translations"

const GuideNumberCheckForm = ({ submit, resetGuideNumber, loadingGuideNumber }) => {
  const { translate } = useContext(I18nContext)
  const { handleSubmit, register, reset } = useForm()

  useEffect(() => {
    resetGuideNumber && reset()
  }, [resetGuideNumber, reset])

  const onSubmit = (data) => submit(data)

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Grid container spacing={2}>
        <Grid item sm={9} xs={12}>
          <TextField
            name="guide_number"
            label={translate("app.guide.packageId")}
            type="text"
            inputRef={register({ required: true })}
            variant="outlined"
            size="small"
            required
            fullWidth
            placeholder="Ej: 67f9320dca9de0bf8eb4ee5d"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip
                    title={translate("app.guide.packageIdIndications")}
                    placement="top"
                    arrow
                  >
                    <IconButton edge="end" size="small" color="primary">
                      <HelpIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            size="large"
            className="btn-rounded"
            disabled={loadingGuideNumber}
            startIcon={loadingGuideNumber && <CircularProgress size={20} color="inherit" />}
          >
            {translate("app.guide.validateGuideBtn")}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default GuideNumberCheckForm
